export const propertyHero = ['$scope', '$window', '$timeout', function ($scope, $window, $timeout) {
  $scope.showFlag = false;
  $scope.dismissFlag = function(post_id) {
    window.sessionStorage.setItem('flag_'+post_id+'_dismissed', true);
    $scope.checkFlagStatus(post_id)
  }
  $scope.checkFlagStatus = function(post_id) {
    var flagDismissed = window.sessionStorage.getItem('flag_'+post_id+'_dismissed');
    $scope.showFlag = !flagDismissed;
  }
}]


document.addEventListener('click', function (e) {
  document
    .querySelectorAll(".property-booking-button-list[data-toggled]")
    .forEach(function (el) {
      if (e.target != el.previousElementSibling) {
        delete el.dataset.toggled;
      }
    });
  if ('bookingButton' in e.target.dataset) {
    e.target.nextElementSibling.toggleAttribute('data-toggled');
  }
})